<form class="mt-2 mb-3" [formGroup]="memberForm" (submit)="save()">
  <div class="form-group">
    <label
      class="form-label mb-0 text-uppercase text-bold text-gray-light small"
      for="inputFirstname"
      >
      <ng-container i18n="@@firstName">First name</ng-container>
    </label>

    <input
      type="text"
      id="inputFirstname"
      formControlName="firstname"
      class="form-control"
      [class.is-invalid]="isFieldInvalid('firstname')"
      placeholder="First name"
      i18n-placeholder="@@firstName"
      />

    <small class="invalid-feedback" i18n>
      Please enter at least 2 characters. This field is required.
    </small>
  </div>

  <div class="form-group">
    <label
      class="form-label mb-0 text-uppercase text-bold text-gray-light small"
      for="inputFirstname"
      >
      <ng-container i18n="@@lastName">Last name</ng-container>
    </label>

    <input
      type="text"
      id="inputLastname"
      formControlName="lastname"
      class="form-control"
      [class.is-invalid]="isFieldInvalid('lastname')"
      placeholder="Last name"
      i18n-placeholder="@@lastName"
      />

    <small class="invalid-feedback" i18n>
      Please enter at least 2 characters.
    </small>
  </div>

  <div class="form-group">
    <label
      class="form-label mb-0 text-uppercase text-bold text-gray-light small"
      i18n
      >
      Profile Image
    </label>

    <maptio-image-upload
      [imageUrl]="picture"
      [userId]="memberId"
      (uploadedImageUrl)="onImageUpload($event)"
      (errorMessage)="onImageUploadError($event)"
      [class.is-invalid]="imageUploadErrorMessage"
    ></maptio-image-upload>

    <small class="invalid-feedback">{{ imageUploadErrorMessage }}</small>
  </div>

  <div class="form-group mb-0">
    <label
      class="form-label mb-0 text-uppercase text-bold text-gray-light small"
      for="inputAbout"
      >
      <ng-container i18n="@@about">About</ng-container>
    </label>

    <textarea
      cdkTextareaAutosize
      cdkAutosizeMinRows="1"
      formControlName="about"
      class="form-control about"
      id="inputAbout"
      data-provide="markdown"
      data-iconlibrary="fa"
      data-autofocus="true"
      [class.is-invalid]="isFieldInvalid('about')"
      placeholder="About"
      i18n-placeholder="@@about"
    ></textarea>

    <small class="invalid-feedback" i18n>
      Please enter at least 2 characters.
    </small>
  </div>

  <small class="text-default text-muted">
    <ng-container i18n="@@markdownTip">
      How to
      <a href="{{ KB_URL_MARKDOWN }}" target="_blank">
        add links and formatting
      </a>
    </ng-container>
  </small>

  <div class="form-group mt-4">
    <label
      class="form-label mb-0 text-uppercase text-bold text-gray-light small"
      for="inputEmail"
      >
      <ng-container i18n="@@email">Email</ng-container>
    </label>

    <input
      type="text"
      id="inputEmail"
      formControlName="email"
      class="form-control"
      [class.is-invalid]="isFieldInvalid('email')"
      placeholder="Email"
      i18n-placeholder="@@email"
      />

    <small class="invalid-feedback" i18n>Please enter a valid email</small>
  </div>

  @if (isUserSignUp) {
    <div class="form-group mt-4">
      <div class="form-check custom-checkbox">
        <input
          type="checkbox"
          id="inputIsTermsAccepted"
          formControlName="isTermsAccepted"
          class="form-check-input"
          [class.is-invalid]="isFieldInvalid('isTermsAccepted')"
          />
        <label
          class="form-label form-check-label"
          for="inputIsTermsAccepted"
          i18n
          >
        I agree to Maptio's
        <a href="{{ TERMS_AND_CONDITIONS_URL }}" target="_blank">
          Terms of Service
        </a>
        and
        <a href="{{ PRIVACY_POLICY_URL }}" target="_blank">Privacy Policy</a>
      </label>
        <small class="invalid-feedback" i18n>
        Please acknowledge accepting the terms before proceeding
      </small>
      </div>
    </div>
  }

  @if (isSavingSuccess) {
    <span
      class="text-green mx-1 flash small"
      [class.show]="isSavingSuccess"
      >
      <i class="fas fa-save"></i>
      <ng-container i18n>Successfully saved!</ng-container>
    </span>
  }

  @if (savingFailedMessage) {
    <span class="text-danger mx-1 small">
      {{ savingFailedMessage }}
    </span>
  }

  @if (!duplicateUsers.length) {
    <div class="d-flex justify-content-end mt-2">
      @if (showCancelButton && !(memberForm.dirty || isNewImageUploaded)) {
        <button
          type="button"
          class="btn btn-outline-secondary me-2"
          (click)="onCancel()"
          >
          <ng-container i18n="@@cancel">Cancel</ng-container>
        </button>
      }
      <!-- TODO Cancel here? Check this out... -->
      @if (showCancelButton && (memberForm.dirty || isNewImageUploaded)) {
        <button
          type="button"
          class="btn btn-outline-secondary me-2"
          placement="top"
          container="body"
          mwlConfirmationPopover
          popoverTitle="Warning"
      popoverMessage="
        Cancelling will reject any unsaved changes. This cannot be undone. Are you sure?
      "
          (confirm)="onCancel()"
          focusbutton="cancel"
          appendToBody="false"
          i18n-popoverTitle="@@warning"
          i18n-popoverMessage
          confirmText="Confirm"
          cancelText="Cancel"
          i18n-confirmText="@@confirm"
          i18n-cancelText="@@cancel"
          >
          <ng-container i18n="@@cancel">Cancel</ng-container>
        </button>
      }
      <button
        type="submit"
        class="btn btn-success"
        [disabled]="isSubmissionAttempted && !memberForm.valid"
        >
        <ng-container i18n="@@save">Save</ng-container>
      </button>
    </div>
  }

  @if (isSaving) {
    <span class="text-green">
      <i class="fas fa-circle-notch fa-spin mx-1"></i>
      <ng-container i18n>Setting up your account</ng-container>
    </span>
  }

  @if (
    duplicateUsers.length &&
    !isDeduplicationTriggeredInternally &&
    !errorMessage
    ) {
    <div
      class="alert alert-warning"
      role="alert"
      >
      <p i18n>
      This email address is already associated with an existing Maptio user:
    </p>
      @for (duplicateUser of duplicateUsers; track duplicateUser) {
        <maptio-member
          [member]="duplicateUser"
          class="d-block mb-2"
        ></maptio-member>
      }
      <p i18n>
      Would you like to add this user to your organisation, or change to a
      different email address?
    </p>
      <div class="d-flex justify-content-end mt-3">
        <button
          type="button"
          class="btn btn-outline-secondary me-2"
          (click)="onCancelDeduplication()"
          i18n
          >
        Change email
      </button>
        <button
          type="button"
          class="btn btn-success"
          (click)="onMergeDuplicateUsers()"
          i18n
          >
        Add existing user
      </button>
      </div>
    </div>
  }

  @if (
    duplicateUsers.length &&
    isDeduplicationTriggeredInternally &&
    !errorMessage
    ) {
    <div
      class="alert alert-warning"
      role="alert"
      >
      <p i18n>
      {duplicateUsers.length, plural, =1 {A person} other {Multiple people}}
      with this name or email address {duplicateUsers.length, plural, =1 {is}
      other {are}} already {duplicateUsers.length, plural, =1 {a member} other
      {members}} of your organisation. Would you like to add
      {duplicateUsers.length, plural, other {them}} instead?
    </p>
      @for (duplicateUser of duplicateUsers; track duplicateUser) {
        <div>
          <maptio-member
            [member]="duplicateUser"
            [isVertical]="true"
            class="d-block mb-2"
          ></maptio-member>
          <button
            type="button"
            class="btn btn-success mt-0 mb-4"
            (click)="onChooseMemberViaDeduplication(duplicateUser)"
            i18n
            >
        Yes, add this person instead
      </button>
        </div>
      }
      <div class="d-flex row container justify-content-start">
        <button
          type="button"
          class="btn btn-outline-secondary me-2"
          (click)="onIgnoreDeduplicationWarning()"
          i18n
          >
        No, add new person
      </button>
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="onCancelDeduplication()"
          >
          <ng-container i18n="@@cancel">Cancel</ng-container>
        </button>
      </div>
    </div>
  }

  @if (errorMessage) {
    <div class="alert alert-danger fade show" role="alert">
      {{ errorMessage }}
    </div>
  }
</form>
